import { PropsWithChildren, createContext, useContext, useState } from 'react'

interface ICofreDigitalData {
  selectedTab: number
  tabOptions: string[]
  changeTab: (tab: number) => void
}

const CofreDigitalsContext = createContext<ICofreDigitalData>({} as ICofreDigitalData)

const CofreDigitalsProvider = ({ children }: PropsWithChildren) => {
  const [selectedTab, setSelectedTab] = useState<number>(0)

  const tabOptions: string[] = ['Tabelas', 'Permissões', 'Serviços']

  const handleChangeTab = (tab: number) => setSelectedTab(tab)

  return (
    <CofreDigitalsContext.Provider
      value={{
        selectedTab,
        changeTab: handleChangeTab,
        tabOptions,
      }}
    >
      {children}
    </CofreDigitalsContext.Provider>
  )
}

const useCofreDigitals = (): ICofreDigitalData => useContext(CofreDigitalsContext)

export { CofreDigitalsProvider, useCofreDigitals }
